import React from 'react';

/**
 * MiniSparkline -- 60x20 SVG inline sparkline.
 *
 * Props:
 *   data: Array<{ avgScore: number }> (at least 2 points)
 *
 * Color logic: green if last >= first, red otherwise.
 */
export default function MiniSparkline({ data }) {
    if (!data || data.length < 2) return null;

    const W = 60;
    const H = 20;
    const PAD = 2;
    const scores = data.map(d => d.avgScore);
    const minS = Math.min(...scores, 0);
    const maxS = Math.max(...scores, 10);
    const range = maxS - minS || 1;

    const points = scores.map((s, i) => ({
        x: PAD + (i / (scores.length - 1)) * (W - PAD * 2),
        y: H - PAD - ((s - minS) / range) * (H - PAD * 2),
    }));

    const pts = points.map(p => `${p.x},${p.y}`).join(' ');
    const lastPt = points[points.length - 1];
    const color = scores[scores.length - 1] >= scores[0] ? '#10b981' : '#ef4444';

    return (
        <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`} className="inline-block">
            <polyline
                points={pts}
                fill="none"
                stroke={color}
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx={lastPt.x} cy={lastPt.y} r={2} fill={color} />
        </svg>
    );
}
